"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var utils_1 = require("../../utils");
var Utils = __importStar(require("./utils"));
var renderLoading = function (isLoading, Loader) {
    if (isLoading) {
        return react_1["default"].createElement(Loader, null);
    }
    return react_1["default"].createElement(react_1["default"].Fragment, null);
};
var messageDefault = {
    success: 'Record has been saved successfully',
    error: 'An error occured while saving your changes'
};
var Form = function (outerProps) {
    return function InnerForm(props) {
        var UI = props.UI, promise = props.promise, onUpdate = props.onUpdate, onToggle = props.onToggle, message = props.message;
        var useSnackbar = outerProps.useSnackbar, Loader = outerProps.Loader;
        var enqueueSnackbar = useSnackbar().enqueueSnackbar;
        var _a = react_1.useState(props.data), data = _a[0], setData = _a[1];
        var _b = react_1.useState(props.errors), errors = _b[0], setErrors = _b[1];
        var _c = react_1.useState(false), isLoading = _c[0], setIsLoading = _c[1];
        var messageToShow = {
            success: message && message.success ? message.success : messageDefault.success,
            error: message && message.error ? message.error : messageDefault.error
        };
        react_1.useEffect(function () {
            setData(__assign({}, props.data));
        }, [props.data]);
        react_1.useEffect(function () {
            setErrors(props.errors);
        }, [props.errors]);
        if (!data) {
            return react_1["default"].createElement(react_1["default"].Fragment, null);
        }
        var handleChange = function (a) {
            var _a;
            return setData(__assign(__assign({}, data), (_a = {}, _a[a.name] = a.value, _a)));
        };
        var handleSubmit = function (e) {
            e.preventDefault();
            setIsLoading(true);
            promise(__assign(__assign({}, data), props.extra), props).then(function (result) {
                setErrors(undefined);
                setIsLoading(false);
                utils_1.confirmMessage(enqueueSnackbar, result.message || messageToShow.success, 'success');
                onUpdate && onUpdate(data, result);
                onToggle && onToggle(false, true);
            }, function (errorResult) {
                var pErrors = Utils.processErrors(errorResult);
                setErrors(pErrors.errorsField);
                setIsLoading(false);
                utils_1.confirmMessage(enqueueSnackbar, pErrors.message ||
                    messageToShow.error ||
                    messageDefault.error ||
                    '', 'error');
            });
        };
        return (react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement(UI, { onSubmit: handleSubmit, onChange: handleChange, onCancel: onToggle, data: data, errors: errors, options: props.options }),
            renderLoading(isLoading, Loader)));
    };
};
exports["default"] = Form;
